<template>
  <div class="app-container">
    <el-card class="card">
      <el-row :gutter="24">
        <!-- <el-col :span="6">
          <el-date-picker
            v-model="condition.bookingTime"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
          >
          </el-date-picker>
        </el-col> -->
        <el-col :span="6">
          <el-select
            :filterable="true"
            remote
            :remote-method="customersFilter"
            :loading="customerRemoteLoading"
            :default-first-option="true"
            v-model="condition.cid"
            clearable
            placeholder="渠道平台"
            style="width:100%"
            v-blurremovereadonly
          >
            <el-option
              v-for="(item, index) in customers"
              :key="index"
              :label="item.name + '(' + item.cid + ')'"
              :value="item.cid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="condition.status" placeholder="状态" clearable style="width:100%">
            <el-option v-for="(item, index) in statusType" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="condition.type" placeholder="类型" clearable style="width:100%">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="search()" icon="el-icon-search">查询</el-button>
          <el-button @click="toResetCondition()" icon="el-icon-refresh">重置</el-button>
          <el-button type="warning" @click="jobAdd()" icon="el-icon-plus">添加</el-button>
          <el-button type="success" @click="templateDownload()" icon="el-icon-download">模版下载 </el-button>
          <!-- <el-button v-if="hasExportPrivilege" type="warning" @click="exportData()" icon="el-icon-download"
            >导出</el-button
          > -->
        </el-col>
      </el-row>
    </el-card>

    <AddView
      :dialogVisible="dialogVisible"
      :jobId="jobId"
      :isView="isView"
      :isCopy="isCopy"
      @dialogView="dialogView"
    ></AddView>

    <el-card class="card_2">
      <el-table
        :data="tableData"
        border
        :row-class-name="getRowClassName"
        v-loading="fullscreenLoading"
        element-loading-text="努力加载中..."
        :header-cell-style="{ background: '#f8f8f9', color: '#000000' }"
        class="table_"
      >
        <el-table-column prop="cid" label="渠道Cid" align="center"> </el-table-column>
        <el-table-column label="航司类型" align="center">
          <template slot-scope="item">
            <span v-if="item.row.carrierType === 0">指定航司一致</span>
            <span v-else-if="item.row.carrierType === 1">包含指定航司</span>
          </template>
        </el-table-column>
        <el-table-column label="TOP类型" align="center">
          <template slot-scope="item">
            <span v-if="item.row.type === 0">航司top3</span>
            <span v-else-if="item.row.type === 1">航线top3</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="item">
            <span v-if="item.row.status === 0">待执行</span>
            <span v-else-if="item.row.status === 1">执行中</span>
            <span v-else-if="item.row.status === 2">执行成功</span>
            <span v-else-if="item.row.status === 3">执行失败</span>
          </template>
        </el-table-column>

        <el-table-column property="requestUrl" label="请求文件" align="center">
          <template slot-scope="scope">
            <span><a style="color: dodgerblue" :href="scope.row.requestUrl">下载</a></span>
          </template>
        </el-table-column>

        <el-table-column property="responseUrl" label="返回文件" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.responseUrl === '' || null == scope.row.responseUrl" style="color: orange"
              >处理中</span
            >
            <span v-if="scope.row.responseUrl != '' && scope.row.responseUrl != null"
              ><a style="color: dodgerblue" :href="scope.row.responseUrl">下载</a></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="" label="执行进度" align="center">
          <template slot-scope="item">
            {{
              item.row.finishCount != 0 ? parseFloat((item.row.finishCount / item.row.totalCount) * 100).toFixed(0) : 0
            }}%
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center"> </el-table-column>
        <el-table-column prop="creator" label="创建人" align="center"> </el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间" align="center"> </el-table-column>
        <el-table-column prop="gmtModified" label="修改时间" align="center"> </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
        @size-change="hadleSizeChange"
        @current-change="handleCerrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currpage"
        :total="total"
        :page-sizes="[10, 20, total]"
        :page-size="pagesize"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import { tokenVerify } from '@/util/common'
import * as commonApi from '@/api/common'
import * as priceCompareJobApi from '@/api/pricecomparejob'
import userManager from '@/sso/user-manager'
import permissionCodes from '@/sso/permission-code'

export default {
  name: 'PriceCompareJobList',
  components: {
    AddView: () => import('@/views/pricecomparejob/detail'),
  },
  data() {
    return {
      tableData: [],
      pagesize: 10,
      currpage: 1,
      total: null,

      customers: [],
      oriCustomers: [],
      customerRemoteLoading: false,
      // 查询参数
      condition: {},

      fullscreenLoading: false,

      statusType: [
        {
          value: 0,
          label: '待执行',
        },
        {
          value: 1,
          label: '执行中',
        },
        {
          value: 2,
          label: '执行成功',
        },
        {
          value: 3,
          label: '执行失败',
        },
      ],
      typeList: [
        {
          value: 0,
          label: '航司最低',
        },
        {
          value: 1,
          label: '最优top3',
        },
      ],
      jobId: null,
      isView: true,
      isCopy: false,
      dialogVisible: false,
    }
  },
  created() {
    this.initCustomer()
    this.getList(this.currpage, this.pagesize)
  },
  methods: {
    exportData() {
      this.$refs.dataExport.exportVisible('/export/l2b/cid', '渠道查定比数据导出')
    },
    getExportPrivilege() {
      return userManager.checkPermission([permissionCodes.L2bStatByCid])
    },
    async initCustomer() {
      //加载渠道列表
      let customerResponse = await this.searchCustomer()
      this.customers = customerResponse.data.data
      this.oriCustomers = customerResponse.data.data
    },
    async customersFilter(name) {
      this.customerRemoteLoading = true
      if (name) {
        let customerResponse = await this.searchCustomer(name)
        this.customers = customerResponse.data.data
      } else {
        this.customers = this.oriCustomers
      }
      this.customerRemoteLoading = false
    },
    async searchCustomer(name) {
      const customerResponse = await commonApi.getCustomerList(name)
      await tokenVerify(this, customerResponse)
      return customerResponse
    },

    async getList(n, m) {
      this.fullscreenLoading = true
      const response = await priceCompareJobApi.queryList(this.condition, n, m)
      if (response.status === 200) {
        if (response.data.status === -1) {
          await this.$router.push({ path: '/login' })
          return
        }
        this.tableData = response.data.data
        this.total = response.data.total
      }
      this.fullscreenLoading = false
    },
    dialogView(d) {
      this.dialogVisible = d
    },
    async search() {
      this.currpage = 1
      await this.getList(this.currpage, this.pagesize)
    },
    jobAdd() {
      this.jobId = null
      this.isView = false
      this.isCopy = false
      this.dialogVisible = true
    },
    toResetCondition() {
      this.condition = {
        cid: null,
        typeList: [],
        statusType: [],
      }
    },
    hadleSizeChange(val) {
      this.pagesize = val
      this.getBookRecordListData(this.currpage, val)
    },
    handleCerrentChange(val) {
      this.currpage = val
      this.getBookRecordListData(val, this.pagesize)
    },
    getRowClassName({ row }) {
      if (row.status === 3) {
        return 'invalid-row'
      }
    },
    templateDownload() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/Excel/Export2Excel')
        const tHeader = ['carrier', 'depCityCode', 'arrCityCode', 'depDate', 'retDate']
        const filterVal = ['carrier', 'depCityCode', 'arrCityCode', 'depDate', 'retDate']
        var tableData = [
          {
            carrier: 'CA',
            depCityCode: 'BJS',
            arrCityCode: 'SHA',
            routes: 'BJS-SHA',
            depDate: '2023-05-11',
            retDate: '2023-05-20',
          },
        ]
        const data = tableData.map((v) => filterVal.map((j) => v[j]))
        export_json_to_excel(tHeader, data, '比价请求模版')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  width: 99%;
  min-width: 720px;
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(11, 37, 64, 0.1);
  border-radius: 4px;
  margin: 10px 10px 12px 10px;
}

.card_2 {
  width: 99%;
  min-width: 720px;
  margin: 0 10px 12px 10px;
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(11, 37, 64, 0.1);
  border-radius: 4px;
}

/deep/.el-table .invalid-row {
  background: rgb(247, 234, 234);
}

.el-date-editor--datetimerange.el-input__inner {
  width: auto;
}
.table_ {
  margin: 20px 0;
}
</style>
